import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react"
import { FaCheckDouble } from "react-icons/fa6"
import _ from "lodash"

import { Link } from "../navigation"
import { IconCheck } from "./icons"

/** A single entity (registration, member, patent, trademark) occupying one country-map cell. */
export interface CountryLink {
    /** Visible label in the multi-item popover, and the sort key. */
    reference: string
    /** Target URL for the link. */
    url: string
    /** Tooltip text; defaults to `reference`. */
    title?: string
}

/**
 * One country-map cell shared across the designs, external, patents and trademarks country maps:
 * a single link shows a check icon; repeated links show a popover listing each entry by reference.
 */
export function CountryLinksCell({ links }: { links: CountryLink[] }) {
    if (links.length === 0)
        return null

    if (links.length === 1) {
        const link = links[0]
        return (
            <Link to={link.url} title={link.title ?? link.reference} className="text-pc-400 h-full text-xs">
                <IconCheck />
            </Link>
        )
    }

    return (
        <Popover className="relative">
            <PopoverButton className="text-pc-400 text-xs h-full">
                <FaCheckDouble className="text-pc-400" />
            </PopoverButton>
            <PopoverPanel className="absolute z-10 px-4 py-2 bg-white dark:bg-pcx-200 border border-pcx-400 rounded shadow">
                <div className="flex flex-col gap-1">
                    {_(links)
                        .sortBy(link => link.reference)
                        .map(link =>
                            <Link key={link.reference} to={link.url} className="text-pc-500 text-sm whitespace-nowrap hover:underline">
                                {link.title ?? link.reference}
                            </Link>
                        )
                        .value()}
                </div>
            </PopoverPanel>
        </Popover>
    )
}
